<template>
  <div>
    <loader :task="task" />
    <message v-if="showMessage" type="warning">
      <slot></slot>
    </message>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loader from './AsyncLinearProgress.vue';
import Message from '../message/Message.vue';

interface Data {
  isLoading: boolean,
  localResource: any|null,
}

export default defineComponent({
  components: {
    Loader,
    Message,
  },
  props: {
    task: Promise,
    resource: {
      type: [Object, Array, String, Number],
    },
  },
  data(): Data {
    return {
      isLoading: false,
      localResource: null,
    };
  },
  computed: {
    actualResource(): any|any[]|null {
      if (this.resource) return this.resource;
      return this.localResource;
    },
    hasResource(): boolean {
      if (Array.isArray(this.actualResource)) {
        return this.actualResource.length > 0;
      }
      return !this.isNil(this.actualResource);
    },
    showMessage(): boolean {
      if (this.isLoading) return false;
      return !this.hasResource;
    },
  },
  watch: {
    task: {
      handler(task: Promise<any>|null) {
        this.isLoading = false;
        this.localResource = null;
        if (!task) return;
        this.isLoading = true;
        task.then((resource: any|null) => {
          this.localResource = resource;
        });
        task.finally(() => {
          this.isLoading = false;
        });
      },
      immediate: true,
    },
  },
  methods: {
    isNil(resource: any): boolean {
      return (resource === undefined || resource === null);
    },
  },
});
</script>
